module.exports = __webpack_public_path__ + "img/report2021.776d9bba.jpg";